import BaseModel from '@/orm/models/BaseModel';
import PayFrequency from '@/orm/models/Dictionary/PayFrequency';
import CountryPayFrequency from '@/orm/models/Country/CountryPayFrequency';
import Currency from '@/orm/models/Dictionary/Currency';
import CountryCurrency from '@/orm/models/Country/CountryCurrency';

export default class Country extends BaseModel {
  static entity = 'countries';

  static primaryKey = 'id';

  static fields() {
    return {
      id: this.attr(null),
      alpha2Code: this.attr(null),
      alpha3Code: this.attr(null),
      name: this.attr(null),
      locale: this.attr(null),
      currencies: this.belongsToMany(
        Currency,
        CountryCurrency,
        'countryId',
        'currencyId',
      ),
      payFrequencies: this.belongsToMany(
        PayFrequency,
        CountryPayFrequency,
        'countryId',
        'payFrequencyId',
      ),
    };
  }

  static apiConfig = {
    actions: {
      fetch() {
        return this.get('countries');
      },
    },
  }
}
